module.exports = __webpack_public_path__ + "assets/img/Culture_001.442a15dc-ps.jpg";